import CONSTANTS from '../../util/constants';

const initState = {
    isLoading: false,
    id: "",
    status: "",
    destination: "",
    location: "",
    condition: "",
    purchaseDate: "",
    getTrailerData: [],
    addTrailerData: []
}

const TrailerManagementReducer = (state = initState, { type, payload }) => {


    switch (type) {
        case CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT.TRAILER_ID_UPDATE:
            return {
                ...state,
                id: payload.value
            }

        case CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT.TRAILER_STATUS_UPDATE:
            return {
                ...state,
                status: payload.value
            }

        case CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT.TRAILER_CONDITION_UPDATE:
            return {
                ...state,
                condition: payload.value
            }

        case CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT.TRAILER_LOCATION_UPDATE:
            return {
                ...state,
                location: payload.value
            }

        case CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT.TRAILER_PURCHASE_DATE_UPDATE:
            return {
                ...state,
                purchaseDate: payload.value
            }

        case CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT.GET_TRAILER_API_SUCCESS:

            return {
                ...state,
                getTrailerData: payload.value
            }
        case CONSTANTS.CONSTANTS_TRAILER_MANAGEMENT.ADD_TRAILER_API_SUCCESS:

            return {
                ...state,
                addTrailerData: payload.value
            }


        default:
            return state
    }
}

export default TrailerManagementReducer;
